"use strict";
exports.__esModule = true;
exports.FieldValidationError = exports.DateRestriction = exports.FieldDocument = void 0;
var FieldDocument = /** @class */ (function () {
    function FieldDocument(org_id, group, name, label, description, field_entity, field_type, has_unique_value, is_global_searchable, is_visible, //For system level fields required for proper function, are hidden in every dropdown and view
    bulk_edit_allowed, is_readonly_definition, //This option shows whether to open edit in fields page or not--Field can be edited like label and all, once created field still can't be changed to different type, readonly field is governed by restriction
    is_readonly_value, created_at, updated_at, created_by, updated_by, is_archived, restriction, rules, option) {
        if (has_unique_value === void 0) { has_unique_value = false; }
        if (is_global_searchable === void 0) { is_global_searchable = false; }
        if (is_visible === void 0) { is_visible = true; }
        if (bulk_edit_allowed === void 0) { bulk_edit_allowed = true; }
        if (is_readonly_definition === void 0) { is_readonly_definition = false; }
        if (is_readonly_value === void 0) { is_readonly_value = false; }
        if (is_archived === void 0) { is_archived = false; }
        this.org_id = org_id;
        this.group = group;
        this.name = name;
        this.label = label;
        this.description = description;
        this.field_entity = field_entity;
        this.field_type = field_type;
        this.has_unique_value = has_unique_value;
        this.is_global_searchable = is_global_searchable;
        this.is_visible = is_visible;
        this.bulk_edit_allowed = bulk_edit_allowed;
        this.is_readonly_definition = is_readonly_definition;
        this.is_readonly_value = is_readonly_value;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.created_by = created_by;
        this.updated_by = updated_by;
        this.is_archived = is_archived;
        this.restriction = restriction;
        this.rules = rules;
        this.option = option;
    }
    FieldDocument.fromJSON = function (json) {
        var field = new FieldDocument('', '', '', '', '', null, null, false, false, true, true, false, false, 0, 0, '', '', false, [], null, []);
        if (json) {
            field.org_id = json.org_id ? json.org_id : '';
            field.group = json.group ? json.group : '';
            field.name = json.name ? json.name : '';
            field.label = json.label ? json.label : '';
            field.description = json.description ? json.description : '';
            field.field_entity = json.field_entity ? json.field_entity : '';
            field.field_type = json.field_type ? json.field_type : '';
            field.has_unique_value = json.has_unique_value !== undefined ? json.has_unique_value : false;
            field.is_global_searchable = json.is_global_searchable !== undefined ? json.is_global_searchable : false;
            field.is_visible = json.is_visible !== undefined ? json.is_visible : true;
            field.bulk_edit_allowed = json.bulk_edit_allowed !== undefined ? json.bulk_edit_allowed : true;
            field.is_readonly_definition = json.is_readonly_definition !== undefined ? json.is_readonly_definition : false;
            field.is_readonly_value = json.is_readonly_value !== undefined ? json.is_readonly_value : false;
            field.created_at = json.created_at ? json.created_at : 0;
            field.updated_at = json.updated_at ? json.updated_at : 0;
            field.created_by = json.created_by ? json.created_by : '';
            field.updated_by = json.updated_by ? json.updated_by : '';
            field.is_archived = json.is_archived !== undefined ? json.is_archived : false;
            field.restriction = json.restriction ? json.restriction : [];
            field.rules = json.rules ? json.rules : null;
            field.option = json.option ? json.option : [];
        }
        return field;
    };
    return FieldDocument;
}());
exports.FieldDocument = FieldDocument;
var DateRestriction;
(function (DateRestriction) {
    DateRestriction["ANY"] = "any";
    DateRestriction["PAST"] = "past";
    DateRestriction["FUTURE"] = "future";
})(DateRestriction = exports.DateRestriction || (exports.DateRestriction = {}));
// Validation Error Class
var FieldValidationError = /** @class */ (function () {
    function FieldValidationError(name, value, related_entity, isValid, message) {
        this.name = name;
        this.value = value;
        this.related_entity = related_entity;
        this.isValid = isValid;
        this.message = message;
    }
    return FieldValidationError;
}());
exports.FieldValidationError = FieldValidationError;
